
<template>
  <div class="jx-div mainContainer" v-loading="loading">
    <div class="cominfo-header" v-if="ismy=='1'" style="padding-top: 20px;">学习中心
      <span>/</span><span>
        <router-link to="/Learning/Mykaoshi">我的考试</router-link>
      </span>
      <span>/</span><span>试题解析</span>
    </div>
    <div class="jx-title disFlex between">
      <div class="jx-title-left disFlex between">
        <div class="disFlex">
          <div>
            <img v-if="sjData.img" style="width: 201px;height: 121px;opacity: 1;border-radius: 6px;"
              :src="wjSrc+sjData.img" />
            <img v-else src="../assets/images/planimg.jpg" style="width: 201px;height: 121px;opacity: 1;border-radius: 6px;"/>
          </div>

          <div class="alignFlex between" style="height: 121px;width: 380px;margin-left: 20px;">
            <div style="font-size: 18px;color: #333;font-weight: 500;">{{sjData.cname}}</div>
            <div style="font-size: 13px;color: #9A9A9A;">总课时：{{sjData.allxstime}} | {{sjData.buyamount}}人购买 |
              有效期：{{sjData.endtime}}</div>
            <div style="font-size: 13px;color: #D50000;">考试用时：{{timeCha.hours>9?timeCha.hours:'0'+timeCha.hours}}时
              {{timeCha.minutes>9?timeCha.minutes:'0'+timeCha.minutes}}分{{timeCha.seconds>9?timeCha.seconds:'0'+timeCha.seconds}}秒
            </div>
          </div>
        </div>
        <div style="text-align: left;width: 100px;margin-right: 10px;">
          <div style="position: relative;">
            <div style="height: 75px;position: absolute;width: 100%;top: 0;left:0;" id="tmddsBfb"></div>
            <div style="height: 75px;font-size: 13px;color: #333;text-align: center;line-height: 75px;">
              {{rightNum}}/{{sjData.ques.length}}
            </div>
          </div>
          <div style="text-align: center;font-size: 13px;color: #9A9A9A;margin-top: 16px;">答对题目数</div>
        </div>

      </div>
      <div class="jx-title-right alignFlex center">
        <div style="font-size: 13px;color: #333333;line-height: 18px;"><span
            style="font-size: 40px;color: #D50000;">{{sjData.fraction}}</span>分
          {{sjData.fraction>=sjData.passfenshu?'合格':'不合格'}}</div>
        <div style="font-size: 13px;color: #333333;line-height: 18px;margin-top: 5px;">
          <span
            v-if="sjData.fraction>=sjData.passfenshu">通过努力，在这次的测验中取得了{{sjData.fraction}}分的好成绩，是非常了不起的，希望能够继续保持努力，加油！</span>
          <span v-else>你听说过这样一句话吗？“天下无难事，只怕有心人”相信只要你也向其他同学一样勤奋学习，你的成绩必须会提高的!</span>
        </div>
      </div>
    </div>
    <div class="disFlex between" style="margin-top: 26px;position: relative;">
      <div class="jx-tiji" id="jx-tiji-divA">
        <div v-for="(item,i) in tiji">
          <div class="jx-ti-block" :id="'jiexiid'+i">
            <div class="jx-ti-block-xh">{{i+1}}</div>
            <div v-if="item.itype=='1'">
              <div class="jx-ti-block-typeName">[单选题]</div>
              <div class="jx-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.dalist"
                :class="a.order==item.daans?('jxradioTm dxright jxradioTm'+i):(item.myanswer!=item.daans&&item.myanswer==a.order?('jxradioTm dxerror jxradioTm'+i):('jxradioTm jxradioTm'+i))">
                <el-radio v-model="item.myanswer" :label="a.order" size="medium" disabled="disabled">{{a.conts}}
                </el-radio>
              </div>
            </div>
            <div v-if="item.itype=='2'">
              <div class="jx-ti-block-typeName">[多选题]</div>
              <div class="jx-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.dalist"
                :class="a.iscorrect?('jxcheckboxTm dxright'):(item.myanswer.indexOf(a.order)>=0&&a.iscorrect=='0'?('jxcheckboxTm dxerror'):('jxcheckboxTm jxcheckboxTm'+i))">
                <el-checkbox disabled v-model="item.myanswer" :key="a.order" :label="a.order">{{a.conts}}</el-checkbox>
              </div>
            </div>
            <div v-if="item.itype=='3'">
              <div class="jx-ti-block-typeName">[判断题]</div>
              <div class="jx-ti-block-tiName">{{item.cname}}</div>
              <div
                :class="item.daans=='1'?'jxradioTm dxright':(item.myanswer==0?'jxradioTm dxerror':'jxradioTm jxradioTm0')">
                <el-radio disabled v-model="item.myanswer" label="1" size="medium">对</el-radio>
              </div>
              <div
                :class="item.daans=='0'?'jxradioTm dxright':(item.myanswer==1?'jxradioTm dxerror':'jxradioTm jxradioTm1')">
                <el-radio disabled v-model="item.myanswer" label="0" size="medium">错</el-radio>
              </div>
            </div>
            <div v-if="item.itype=='4'">
              <div class="jx-ti-block-typeName">[填空题]</div>
              <div class="jx-ti-block-tiName">
                <span v-for="a in item.dalist" class="tiankong-inp">
                  <span v-if="a.type=='text'">{{a.conts}}</span>
                  <el-input v-else v-model="a.conts" placeholder="请输入内容"></el-input>
                </span>
              </div>
            </div>
            <div v-if="item.itype=='5'">
              <div class="jx-ti-block-typeName">[简答题]</div>
              <div class="jx-ti-block-tiName">{{item.cname}}</div>
              <div>
                <el-input type="textarea" :rows="2" disabled placeholder="请输入您的答案" v-model="item.myanswer"></el-input>
              </div>
            </div>
          </div>
          <div class="jxnr-cont" v-if="item.itype=='1'">
            <div class="jxnr-cont-header">
              <div class="bj-dnzqcw">{{item.daans==item.myanswer?'回答正确':'回答错误'}}</div>
              <span>正确答案：</span><span style="color: #00BC68;">{{danxuanx[item.daans]}}</span>
              <span style="padding-left: 54px;">我的答案：</span><span
                :style="item.daans==item.myanswer?'color: #00BC68;':'color: #D50000;'">{{danxuanx[item.myanswer]}}</span>
            </div>
            <div class="jxnr-cont-jiexi disFlex">
              <div style="width: 90px;color: #9A9A9A;">答案解析：</div>
              <div style="width: 100%;">{{item.description}}</div>
            </div>
          </div>
          <div class="jxnr-cont" v-if="item.itype=='2'">
            <div class="jxnr-cont-header">
              <div class="bj-dnzqcw">{{item.useriscorrect?'回答正确':'回答错误'}}</div>
              <span>正确答案：</span><span style="color: #00BC68;">{{item.daans.join(',').replace('1', 'A').replace('2', 'B').replace('3', 'C').replace('4', 'D')
            .replace('5', 'E')}}</span>
              <span style="padding-left: 54px;">我的答案：</span><span
                :style="item.myanswer?'color: #00BC68;':'color: #D50000;'">{{item.myanswer.join(',').replace('1', 'A').replace('2', 'B').replace('3', 'C').replace('4', 'D')
            .replace('5', 'E')}}</span>
            </div>
            <div class="jxnr-cont-jiexi disFlex">
              <div style="width: 90px;color: #9A9A9A;">答案解析：</div>
              <div style="width: 100%;">{{item.description}}</div>
            </div>
          </div>
          <div class="jxnr-cont" v-if="item.itype=='3'">
            <div class="jxnr-cont-header">
              <div class="bj-dnzqcw">{{item.useriscorrect?'回答正确':'回答错误'}}</div>
              <span>正确答案：</span><span style="color: #00BC68;">{{panarr[item.daans]}}</span>
              <span style="padding-left: 54px;">我的答案：</span><span
                :style="item.useriscorrect?'color: #00BC68;':'color: #D50000;'">{{panarr[item.myanswer]}}</span>
            </div>
            <div class="jxnr-cont-jiexi disFlex">
              <div style="width: 90px;color: #9A9A9A;">答案解析：</div>
              <div style="width: 100%;">{{item.description}}</div>
            </div>
          </div>
          <div class="jxnr-cont" v-if="item.itype=='5'">
            <div class="jxnr-cont-header">
              <div class="bj-dnzqcw">{{item.useriscorrect?'回答正确':'回答错误'}}</div>
            </div>
            <div class="jxnr-cont-jiexi disFlex">
              <div style="width: 90px;color: #9A9A9A;">答案解析：</div>
              <div style="width: 100%;">{{item.description}}</div>
            </div>
          </div>
        </div>
      </div>
      <div :class="KsBtnIsfixed?'jx-datika fixed':'jx-datika'">
        <div class="disFlex between">
          <div class="jx-datika-name">答题卡</div>
          <div class="jx-datika-wcd"></div>
        </div>
        <div class="disFlex"
          style="align-items: center;margin: 20px 0;font-size: 14px;color: #333;letter-spacing: 1px;">
          <div class="small-block-dd"></div>答对
          <div class="small-block-dc"></div>打错
          <div class="small-block-wd"></div>未答
        </div>
        <div v-for="t in itypeList">
          <div class="ti-type">
            {{t=='1'?'单选题':''}}
            {{t=='2'?'多选题':''}}
            {{t=='3'?'判断题':''}}
            {{t=='4'?'填空题':''}}
            {{t=='5'?'简答题':''}}
          </div>
          <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='1'">
            <div v-for="(item,i) in tiji"
              :style="item.useriscorrect=='1'?'':(!item.useriscorrect&&item.myanswer?'background:#D50000;color:#fff;':'')"
              :class="item.useriscorrect=='1'?'jx-xuhao-block active':'jx-xuhao-block'" v-if="item.itype=='1'"
              @click="goToTiji(i)">
              {{i+1}}
            </div>
          </div>
          <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='2'">
            <div v-for="(item,i) in tiji"
              :style="item.useriscorrect=='1'?'':(!item.useriscorrect&&item.myanswer.length>0?'background:#D50000;color:#fff;':'')"
              :class="item.useriscorrect=='1'?'jx-xuhao-block active':'jx-xuhao-block'" v-if="item.itype=='2'"
              @click="goToTiji(i)">{{i+1}}
            </div>
          </div>
          <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='3'">
            <div v-for="(item,i) in tiji"
              :style="item.useriscorrect=='1'?'':(item.useriscorrect=='0'?'background:#D50000;':'')"
              :class="item.myanswer?'jx-xuhao-block active':'jx-xuhao-block'" v-if="item.itype=='3'"
              @click="goToTiji(i)">{{i+1}}</div>
          </div>
          <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='4'">
            <div v-for="(item,i) in tiji" :class="item.myanswer?'jx-xuhao-block active':'jx-xuhao-block'"
              v-if="item.itype=='4'" @click="goToTiji(i)">{{i+1}}</div>
          </div>
          <div class="disFlex" style="flex-wrap: wrap;" v-if="t=='5'">
            <div v-for="(item,i) in tiji"
              :style="item.useriscorrect=='1'?'':(item.useriscorrect=='0'?'background:#D50000;':'')"
              :class="item.myanswer?'jx-xuhao-block active':'jx-xuhao-block'" v-if="item.itype=='5'"
              @click="goToTiji(i)">{{i+1}}</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getTimer
  } from '@/assets/js/common.js';
  import * as echarts from 'echarts';
  export default {
    name: 'Ckjx',
    props: ['KsBtnIsfixed'],
    data() {
      return {
        wjSrc: 'http://192.168.0.108:8082/jtzy/',
        width: 'width:0%',
        progress: '0%',
        danxuanx: ['', 'A', 'B', 'C', 'D', 'E', 'F', 'G'],
        tiji: [],
        yidaNum: 0,
        sjData: {
          ques: []
        },
        itypeList: [],
        panarr: ['B', 'A'],
        timeCha: {
          hours: 0,
          minutes: 0,
          seconds: 0
        },
        rightNum: 0,
        loading: true,
        ismy: ''
      }
    },
    methods: {
      // 获取答题情况
      getJincheng: function(newVal) {
        var yidaNum = 0;
        newVal.map((item) => {
          if (item.itype == '2') {
            if (item.myanswer.length > 0) {
              yidaNum++
            }
          }
          if (item.itype == '1' || item.itype == '5' || item.itype == '3') {
            if (item.myanswer || item.myanswer == '0') {
              yidaNum++
            }
          }
          // 填空题所有的空填完才算完成一题
          if (item.itype == '4') {
            var isqt = true
            item.dalist.map((a) => {
              if (a.type == 'input' && !a.conts) {
                isqt = false
              }
            });
            if (isqt) {
              item.myanswer = true
              yidaNum++
            } else {
              item.myanswer = false
            }
          };
        });
        this.yidaNum = yidaNum;
        this.progress = parseInt((yidaNum / newVal.length) * 100) + '%';
        this.width = 'width:' + this.progress;
      },
      getStlist: function(id) {
        this.loading = true;
        this.$axios.get('/kt/ktQuestionsUser/detail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.sjData = data.data;
            var timeCha = getTimer(data.data.startTime, data.data.createTime);
            this.timeCha = timeCha;
            var list = [];
            var itypeList = [];
            var rightNum = 0;
            data.data.ques.map((item, i) => {
              var a = [];
              var daans;
              item.dalist.map((d) => {
                // 选择题
                if (item.itype == '1' && d.iscorrect == '1') {
                  daans = d.order;
                } else if (item.itype == '2' && d.iscorrect == '1') {
                  // 多选题
                  a.push(d.order);
                } else if (item.itype == '3') {
                  // 判断题
                  daans = d.iscorrect;
                }
              });
              var listobj = {
                ...item,
                daans: item.itype == '2' ? a : daans,
                myanswer: item.itype == '2' ? (item.userconts ? item.userconts.split(',').map(Number) :
                []) : item.userconts
              };
              // if(item.itype=='2'){
              //   // listobj.useriscorrect=JSON.stringify(listobj.daans.sort()) === JSON.stringify(listobj.myanswer.sort())
              // }
              list.push(listobj);
              if (i == 0 || item.itype != data.data.ques[i - 1].itype) {
                if (itypeList.indexOf(item.itype) == '-1') {
                  itypeList.push(item.itype)
                }
              }
              if (item.useriscorrect == '1') {
                rightNum++;
              }
            });
            this.tiji = list;
            this.itypeList = itypeList;
            this.rightNum = rightNum;
            this.getBfb(rightNum, data.data.ques.length);
            this.loading = false;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      getBfb: function(num1, numall) {
        var num2 = numall - num1;
        var option = {
          title: {
            show: false
          },
          tooltip: {
            trigger: 'item',
            show: false
          },
          legend: {
            top: '5%',
            left: 'center',
            show: false
          },
          color: ['#0071BA', '#EFEFEF'],
          series: [{
            name: '答对题目数',
            type: 'pie',
            radius: ['85%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [{
                value: num1,
                name: '答对'
              },
              {
                value: num2,
                name: '题目数'
              },
            ]
          }]
        };

        var myChart = echarts.init(document.getElementById('tmddsBfb'));
        myChart.setOption(option);
      },
      goToTiji: function(i) {
        var el = document.getElementById('jiexiid' + i);
        $('#jx-tiji-divA').animate({
          scrollTop: el.offsetTop
        }, 300);
      }
    },
    components: {},
    created: function() {
      var url = "";
      //108网  crm
      if (window.location.host.indexOf('demo.tsanquan.com') != '-1') {
        url = 'http://dstatic.tsanquan.com';
      } else if (window.location.host.indexOf('localhost') != '-1') {
        url = 'http://192.168.0.108:8082/jtzy';
      } else {
        url = window.location.origin + '/jtzy';
      };
      this.wjSrc = url;
      this.ismy = this.$route.query.ismy;
      this.getStlist(sessionStorage.getItem('myanswerId'));
    },
    mounted: function() {

    },
    watch: {
      tiji: {
        handler(newVal) {
          this.getJincheng(newVal);
        },
        deep: true
      }
    }
  }
</script>

<style>
  .jx-title {
    background-color: #fff;
    border-radius: 4px;
    padding: 15px;
    margin-top: 20px;
  }

  .jx-title-top {
    opacity: 1;
    font-size: 24px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: center;
    color: #333333;
    line-height: 33px;
    padding: 25px 0;
    border-bottom: 1px solid #efefef;
    ;
  }

  .jx-title-left {
    border-right: 1px solid #EFEFEF;
    width: 877px;
  }

  .jx-title-right {
    width: 290px;
    padding-left: 20px;
  }

  .jx-title-bg {
    width: 1137px;
    height: 12px;
    opacity: 1;
    background: #efefef;
    border-radius: 7px;
    margin-bottom: 17px;
  }

  .jx-title-bg .progress {
    height: 12px;
    width: 20%;
    background: #0071BA;
    border-radius: 7px;
    transition: all 0.3s linear;
  }

  .jx-tiji {
    width: 853px;
    height: calc(100vh - 50px - 192px);
    overflow-y: auto;
  }

  .jx-ti-block {
    padding: 26px 40px 26px 66px;
    background: #ffffff;
    position: relative;
  }

  .jx-ti-block-xh {
    position: absolute;
    width: 44px;
    height: 29px;
    opacity: 1;
    height: 37px;
    background: url(../assets/images/ksxh.png) 0 0 no-repeat;
    background-size: 100% 100%;
    left: -10px;
    top: 21px;
    color: #fff;
    line-height: 29px;
    text-align: center;
  }

  .jx-ti-block-typeName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #0071BA;
    line-height: 20px;
    letter-spacing: 1px;
    padding-bottom: 8px;
  }

  .jx-ti-block-tiName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 22px;
  }

  /* 单选的样式   自定义 开始*/
  .jxradioTm {
    padding-bottom: 15px;
    text-align: left;
  }

  .jxradioTm .el-radio__inner {
    width: 24px;
    height: 24px;
    background: #efefef !important;
    border-radius: 50%;
  }

  .jxradioTm .el-radio__input.is-checked .el-radio__inner {
    background: #00BC68 !important;
    border: 1px solid #00BC68 !important;
  }

  .jxradioTm .el-radio__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .jxradioTm0 .el-radio__inner::after {
    content: "A";
  }

  .jxradioTm1 .el-radio__inner::after {
    content: "B";
  }

  .jxradioTm2 .el-radio__inner::after {
    content: "C";
  }

  .jxradioTm3 .el-radio__inner::after {
    content: "D";
  }

  .jxradioTm .is-checked .el-radio__inner::after {
    color: #FFF;
  }

  .jxradioTm .el-radio__input.is-checked+.el-radio__label {
    color: #333;
  }

  .jxradioTm.dxright .el-radio__inner::after {
    content: "√";
    background: #00BC68 !important;
    color: #FFF;
  }

  .jxradioTm.dxerror .el-radio__inner::after {
    content: "×";
    background: #D50000 !important;
    color: #FFF;
  }

  /* 单选的样式   自定义 结束*/
  /* 多选的样式   自定义 开始*/
  .jxcheckboxTm {
    text-align: left;
    padding-bottom: 15px;
  }

  .jxcheckboxTm .el-checkbox__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .jxcheckboxTm .el-checkbox__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .jxcheckboxTm0 .el-checkbox__inner::after {
    content: "A";
  }

  .jxcheckboxTm1 .el-checkbox__inner::after {
    content: "B";
  }

  .jxcheckboxTm2 .el-checkbox__inner::after {
    content: "C";
  }

  .jxcheckboxTm3 .el-checkbox__inner::after {
    content: "D";
  }

  .jxcheckboxTm4 .el-checkbox__inner::after {
    content: "E";
  }

  .jxcheckboxTm5 .el-checkbox__inner::after {
    content: "F";
  }

  .jxcheckboxTm6 .el-checkbox__inner::after {
    content: "G";
  }

  .jxcheckboxTm .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: translate(-50%, -50%) scale(1);
    background-color: #00BC68;
    color: #fff;
  }

  .jxcheckboxTm .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #00BC68;
  }

  .jxcheckboxTm .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #00BC68;
    background-color: #00BC68;
  }

  .jxcheckboxTm .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
  }

  .jxcheckboxTm.dxright .el-checkbox__inner::after {
    content: "√";
    background: #00BC68 !important;
    color: #FFF;
  }

  .jxcheckboxTm.dxerror .el-checkbox__inner::after {
    content: "×";
    background: #D50000 !important;
    color: #FFF;
  }

  /* 多选的样式   自定义 结束*/
  /* 输入框样式 */
  .tiankong-inp .el-input {
    width: 100px;
    margin: 0 5px;
  }

  .tiankong-inp .el-input .el-input__inner {
    border: none;
    border-bottom: 1px solid #d0d0d0;
    border-radius: 0;
  }

  /* 输入框样式 */
  .jx-datika {
    width: 286px;
    background: #ffffff;
    padding: 20px;
    border-radius: 4px;
    height: calc(100vh - 91px - 192px);
    overflow-y: auto;
  }

  .jx-datika .jx-datika-name {
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
  }

  .jx-datika-wcd {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .small-block-dd {
    width: 14px;
    height: 14px;
    opacity: 1;
    background: #00BC68;
    border-radius: 1px;
    margin-right: 6px;
  }

  .small-block-dc {
    width: 14px;
    height: 14px;
    opacity: 1;
    background: #D50000;
    border-radius: 1px;
    margin: 0 6px 0 14px;
  }

  .small-block-wd {
    width: 14px;
    height: 14px;
    opacity: 1;
    background: #d8d8d8;
    border-radius: 1px;
    margin: 0 6px 0 14px;
  }

  .ti-type {
    margin: 12px 6px 12px 0;
    text-align: left;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
  }

  .jx-xuhao-block {
    width: 36px;
    height: 36px;
    background: #efefef;
    border-radius: 1px;
    color: #333;
    text-align: center;
    line-height: 36px;
    margin: 5px 5px;
    cursor: pointer;
  }

  .jx-xuhao-block.active {
    width: 36px;
    height: 36px;
    background: #00BC68;
    border-radius: 1px;
    color: #fff;
  }

  .tijiao-junazi {
    width: 100%;
    border-radius: 25px;
    font-size: 20px;
    font-family: 'PingFangSC';
    font-weight: 500;
  }

  .jxnr-cont {
    margin-bottom: 20px;
  }

  .jxnr-cont-header {
    height: 39px;
    opacity: 1;
    background: #f2f2f2;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    line-height: 39px;
    letter-spacing: 1px;
    position: relative;
    padding-left: 103px;
  }

  .bj-dnzqcw {
    position: absolute;
    width: 95px;
    height: 37px;
    opacity: 1;
    background: url(../assets/images/anwserjx.png) 0 0 no-repeat;
    background-size: 100% 100%;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 29px;
    left: -10px;
    top: -15px;
  }

  .jxnr-cont-jiexi {
    padding: 15px 13px;
    background-color: #fff;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 21px;
    letter-spacing: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ckjx.vue